import { render } from "./multiple-select-product.vue?vue&type=template&id=3efc5ad4&ts=true"
import script from "./multiple-select-product.vue?vue&type=script&lang=ts"
export * from "./multiple-select-product.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__